module.exports = __webpack_public_path__ + "static/media/icon.a9784e0a.png";